import React from "react";

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      title: "Post A Job",
      description:
        "Post a job easily and connect with top candidates, streamlining your hiring process for better result",
      icon: "📝", // Replace with your desired icon
    },
    {
      id: 2,
      title: "Find Employers",
      description:
        "Discover the top talent and find the right Candidates to grow your team",
      icon: "🔍", // Replace with your desired icon
    },
    {
      id: 3,
      title: "Pay Safely",
      description:
        "Ensure secure payments for services, providing peace of mind with trusted and reliable payment options",
      icon: "💰", // Replace with your desired icon
    },
    {
      id: 4,
      title: "We’re Here To Help",
      description:
        "We’re always ready to assist you, ensuring a smooth experience throughout your hiring or job search journey",
      icon: "🙌", // Replace with your desired icon
    },
  ];

  return (
    <section className="bg-background text-textWhite mt-2 font-josefin py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-center text-3xl font-bold mb-8">How It Works</h2>
        <p className="text-center mb-12 text-lg">
          Simplify hiring with smart channels to quickly find qualified
          candidates, saving time and improving the quality of hires.{" "}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {steps.map((step) => (
            <div
              key={step.id}
              className="bg-boxes p-6 rounded-lg hover:bg-teal-700 transition duration-300"
            >
              <div className="text-6xl mb-4">{step.icon}</div> {/* Icon */}
              <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
              <p className="text-sm">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
